import React, {useMemo} from 'react';
import styled from "styled-components";
import ChampionImageWithLane from "../common/ChampionImageWithLane";
import LLMChampionImage from "./llmChampionImage";
import {threedigits} from "../../function";
import {useTranslation} from "react-i18next";

const Wrapper = styled.div`
  margin-top: 16px;
  width: 616px;
`;


const ChampionImageBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 136px;
  height: 136px;
  border-radius: 100%;
  border: 4px solid ${props => {
    let color = '#E85C5C'
    if (props.isWin) {
      color = '#4C92FC';
    }
    return color
  }};


`;

const EmptyChampionImageBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 136px;
  height: 136px;
  border: 4px solid ${props => props.theme.color.default_border_color};
  border-radius: 100%;
`;
const EmptyImage = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 100%;
  background-color: ${props => props.theme.color.default_border_color};
`;
const VersusText = styled.span`
  font-weight: 500;
  font-size: 32px;
  color: ${props => props.theme.color.dark_200};
`;
const ChampionImageWrapper = styled.div`
  height: 136px;
  padding: 0 66px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .imgDiv {
    border-radius: 100%;
  }

  .imgChampEmpty {
    width: 100px;
    height: 100px;
  }

  .imgChamp {
    width: 106px;
    height: 106px;
  }
`;
const ConditionRowBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
`;
const LlmChampionCompare = ({pickChampion, againstChampion, data,}) => {

    const winRateMemo = useMemo(() => {
        try {
            return {
                enemy_win_rate: data.enemy_win_rate,
                my_win_rate: data.my_win_rate,
                games: data.games
            }
        } catch (e) {

            return {
                enemy_win_rate: 0,
                games: 0,
                my_win_rate: 0
            }
        }
    }, [data]);
    const isLeftBlue = useMemo(() => {
        try {
            if (winRateMemo.enemy_win_rate === winRateMemo.my_win_rate) {
                return true;
            }
            return winRateMemo.my_win_rate > 50
        } catch (e) {
            return false;
        }
    }, [winRateMemo]);


    return (
        <Wrapper>
            <ChampionImageWrapper>
                <LLMChampionImage championId={pickChampion?.champion_id} isWin={isLeftBlue}
                                  disabled={winRateMemo.games === 0}/>
                <VersusText>VS</VersusText>
                <LLMChampionImage championId={againstChampion?.champion_id} isWin={!isLeftBlue}
                                  disabled={winRateMemo.games === 0}/>
            </ChampionImageWrapper>
            <WinBox winValue={winRateMemo.my_win_rate} count={winRateMemo.games}/>
            {/*{winRateMemo.games > 0 &&*/}
            {/*    <div>*/}
            {/* */}
            {/*        <ConditionRowBox>*/}
            {/*            {tips.levelAdvantage.map((data, index) => {*/}
            {/*                return (*/}
            {/*                    <CompareCondition title={getCompareTitle(data)} isWin={data.status === '유리'} key={index}/>*/}
            {/*                )*/}
            {/*            })}*/}
            {/*        </ConditionRowBox>*/}
            {/*    </div>}*/}
        </Wrapper>
    );
};

const ChampionImage = ({champion}) => {


    if (!champion?.champion_id) {
        return (
            <EmptyChampionImageBox>
                <EmptyImage/>
            </EmptyChampionImageBox>
        )
    }

    return (
        <ChampionImageBox isWin={false}>
            <ChampionImageWithLane champion_id={champion?.champion_id} disableScale={true}/>
        </ChampionImageBox>
    )
}

const WinBoxWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const WinBoxItem = styled.div`
  width: 480px;
`;

const WinText = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: ${props => props.theme.color.dark_200};
  line-height: 17px;
`;

const WinRateBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  line-height: 38px;
  margin-bottom: 4px;
  margin-top: 8px;
`;

const WinBoxCountSpan = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: ${props => props.theme.color.green_100};
`;

const WinBoxCount = styled.span`
  font-weight: 600;
  font-size: 20px;
  color: ${props => props.theme.color.dark_200_white};
  margin-left: 8px;
`;
const WinBoxCountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 24px;
`;

const EmptyGauge = styled.div`
  height: 8px;
  width: 100%;
`;
const WinBox = ({winValue, count}) => {
    const {t} = useTranslation();
    const enemyWin = 100 - winValue
    return (
        <WinBoxWrapper>
            <WinBoxItem>
                <WinRateBox>
                    <WinRate value={winValue} disabled={count === 0}/>
                    <WinBoxCountWrapper>
                        <WinBoxCountSpan>
                            {t('llm.sampleSize')}
                        </WinBoxCountSpan>
                        <WinBoxCount>
                            {threedigits(count)}
                        </WinBoxCount>
                    </WinBoxCountWrapper>
                    <WinRate reverse={true} value={enemyWin} disabled={count === 0}/>
                </WinRateBox>
                {count > 0 ?
                    <Gauge value={winValue} isWin={winValue >= 50}/> : <EmptyGauge/>}
            </WinBoxItem>
        </WinBoxWrapper>
    )
}

const WinRateText = styled.span`
  font-weight: 600;
  font-size: 32px;
  color: ${props => {
    let color = props.theme.color.red_100
    if (props.isWin) {
      color = props.theme.color.blue_100
    }
    if (props.disabled) {
      color = props.theme.color.dark_100
    }
    return color
  }};
`;
const Percent = styled.span`
  font-weight: 600;
  font-size: 32px;
  color: ${props => props.theme.color.dark_200};
`;

const WinRateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const WinRate = ({reverse, value, disabled}) => {
    const{t} = useTranslation();
    const renderValue = useMemo(() => {
        if (disabled) {
            return 0
        }
        return value?.toFixed(2)
    }, [disabled, value])
    return (
        <WinRateWrapper reverse={reverse}>
            <WinText>{t('llm.matchUpRate')}</WinText>
            <WinRateText isWin={reverse ? value > 50 : value >= 50}
                         disabled={disabled}>{renderValue}<Percent>%</Percent></WinRateText>
        </WinRateWrapper>
    )
}
const Graph = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 8px;
  background-color: ${props => {
    let color = '#4C92FC'

    if (props.isWin) {
      color = '#E85C5C'
    }
    return color
  }};
`;
const Filled = styled.div`
  height: 8px;
  width: ${props => props.percent}%;
  background-color: ${props => {
    let color = '#E85C5C'
    if (props.isWin) {
      color = '#4C92FC'
    }
    return color
  }};
  position: relative;
`;
const Gauge = ({value, isWin}) => {


    return (
        <Graph isWin={isWin}>
            <Filled percent={value} isWin={isWin}/>
        </Graph>
    )
}
const ConditionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ConditionBox = styled.div`
  width: 136px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${props => {
    let color = '#E85C5C'
    if (props.isWin) {
      color = '#4C92FC'
    }
    return color;
  }};
  color: #fff;
`;

const ConditionText = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: ${props => props.theme.color.dark_100};
  margin-top: 4px;
  line-height: 24px;
  margin-top: 4px;
`;
const CompareCondition = ({title, isWin}) => {
    return (
        <ConditionWrapper>
            <ConditionBox isWin={isWin}>
                <span>{title}</span>
            </ConditionBox>
            <ConditionText>
                {isWin ? '유리함' : '불리함'}
            </ConditionText>
        </ConditionWrapper>
    )
}

export default LlmChampionCompare;